var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_38343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78247 14.3478C6.78247 15.2122 7.48325 15.913 8.34767 15.913H13.0433C13.0433 16.6334 13.6273 17.2174 14.3477 17.2174H15.9129C16.6333 17.2174 17.2172 16.6334 17.2172 15.913V14.3478H6.78247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3477 6.78262V10.4348C17.3477 11.0102 16.8796 11.4783 16.3042 11.4783V13.0435C17.7427 13.0435 18.9129 11.8732 18.9129 10.4348V6.78262H17.3477Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1304 10.4348C6.1304 11.0102 5.6623 11.4783 5.08691 11.4783V13.0435C6.52537 13.0435 7.6956 11.8732 7.6956 10.4348V6.78262H6.1304V10.4348Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.78262H16.5652V10.4348H15V6.78262Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6522 8.86955C12.6522 9.01341 12.5351 9.13041 12.3913 9.13041C12.2475 9.13041 12.1304 9.01336 12.1304 8.86955V6.78258H10.5652V8.86955C10.5652 9.01341 10.4482 9.13041 10.3044 9.13041C10.1606 9.13041 10.0435 9.01336 10.0435 8.86955V6.78258H8.47827V8.86955C8.47827 9.87647 9.29746 10.6957 10.3044 10.6957C10.6922 10.6957 11.0518 10.5738 11.3479 10.3668C11.6439 10.5737 12.0036 10.6957 12.3913 10.6957C12.4694 10.6957 12.5462 10.6902 12.6217 10.6806C12.5108 11.1375 12.0993 11.4782 11.6087 11.4782V13.0434C13.0472 13.0434 14.2174 11.8732 14.2174 10.4347V8.86955V6.78258H12.6522V8.86955H12.6522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47827 11.4783H10.8261V13.0435H8.47827V11.4783Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_38343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.605ca2cd579ef1b8bf35fe65859c63cb.svg";
export { ForwardRef as ReactComponent };